<template>
  <div :id="localId" class="svg_wrapper"></div>
</template>

<script>
import mx_Core from './includes/mixins/zMixins'        

export default {
  name: "j-chart-table-el",
  mixins: [mx_Core],
  props: {
    id: String,
    modeExport: Boolean,
    getSelectItems: String,  

    FilterValues: { type: Object, default: () => ({}) },
    ColumnProps: { type: Array, default: () => ([]) },
    Canvas: { type: Object, default: () => ({}) },
    Text: { type: Object, default: () => ({}) },
    DataItems: { type: Array, default: () => ([]) },
    Queries: { type: Object, default: () => ({}) },
    JQueries: { type: Object, default: () => ({}) },
  }, 

  created() {
    this.localId = `${this.id || 'j-chart-custom'}__${this.safeId('')}`

    this.cbDataReady = new Promise(resolve => {
      this.resolveCbData = resolve
    })
  },

  mounted() {
    this.register(this.draw)
  },
  
  methods: {

    makeProcId() {
      return `${this.localId}_EXCEL_EXPORT_PROC`
    },

    onCallbackSvg(ret) {
      // console.log('svg3 onCallbackSvg', ret)
      this.cbData = ret
      this.resolveCbData(ret)

      if (this.callback) {
        if (typeof this.callback.onCallbackSvg === 'function') {
          // console.log('svg3 onCallbackSvg call callback.onCallbackSvg', ret)
          this.callback.onCallbackSvg(ret)
        }
      }
      this.$emit('procedure-response', ret)
    },

    draw() {
      if (!this.ready2draw) {
        return
      }
      this.clear()
      this.app_Colors()
      this.set_LocalValues()
      this.drawCanvas()
      // this.drawing()  
      this.drawTexts()
      this.complete()
    },

    drawing() {
      this.set_Canvas()
    },
  }
}
</script>


<style lang="scss">

.input {
  padding: 2px 5px 1px 5px; 
  font-size: 12px; 
  line-height: 18px; 
  height: 23px;
  border: 1px  solid #ccc; 
  // border-bottom: 1px  solid #ccc; 
  outline: none; 
  box-sizing: border-box;
  white-space: nowrap;
  cursor: text;
}
 
</style>